import React, { useMemo } from 'react';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import VoxelComboBox, { VoxelComboBoxProps } from '../../voxel/Forms/VoxelComboBox';

export interface VoxelAutocompleteAllDomainsProps extends Omit<VoxelComboBoxProps, 'options'> { }

export const VoxelAutocompleteAllDomains: React.FC<VoxelAutocompleteAllDomainsProps> = (props) => {
  const domainQuery = projectsApiService.queries.useGetProjectDomains({});

  const domains = useMemo(() => domainQuery?.data?.domains ?? [], [domainQuery?.data?.domains]);
  return <VoxelComboBox label={'Domain'} options={domains} {...props} />;
};

export default VoxelAutocompleteAllDomains;
